import ConfirmDeleteAssetModal from './ConfirmDeleteAssetModal'
export default ConfirmDeleteAssetModal
